module.exports = __webpack_public_path__ + "static/img/伙伴客户-新疆人民医院.889d6072.png";